module.exports = __webpack_public_path__ + "static/media/water_pump_battery.c034aed2.jpg";